// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
import VueMatomo from 'vue-matomo'
import jquery from 'jquery'
import Swiper from 'swiper'
import VueLazyLoad from 'vue-lazyload'
import {get,get2,post} from '../src/api/api'
import radiogtag from '../static/js/radio_ga'
import frenchgtag from '../static/js/french_ga'
// 全局组件 start
import aLink from "./components/common/aLink/"
import MessageBox from './components/common/article-dialog';
import ShareDialog from './components/common/share-dialog';
import SubscribeDialog from './components/common/subscribe-dialog';
import PolicyDialog from './components/common/policy-dialog';
import DangerIpDialog from './components/common/danger-ip-dialog';

// 全局组件 end
import 'video.js/dist/video-js.css'
import 'swiper/dist/css/swiper.css'
import '../static/css/common.css'
import '../static/css/rtl-font.css'
import '../static/css/header_v3.css'
import '../static/css/footer_v3.css'
import '../static/css/style.css'
import '../static/sass/style.scss'
Vue.config.productionTip = false
// 是否调用静态接口
Vue.prototype.isStaticRequest = true;
Vue.prototype.$get = get;
Vue.prototype.$get2 = get2;
Vue.prototype.$post = post;
Vue.prototype.$EventBus = new Vue();
Vue.use(VueMatomo, {
  host: 'https://matomo.meldingcloud.com', // 这里配置你自己的piwik服务器地址和网站ID
  siteId: 24,//siteId值
  // 根据router自动注册
  router: router,
  // // 是否需要在发送追踪信息之前请求许可
  // // 默认false
  requireConsent: false,
  enableLinkTracking: true,
  // // 是否追踪初始页面
  // // 默认true
  trackInitialView: false,
  // // 最终的追踪js文件名
  // // 默认 'piwik'
  trackerFileName: 'matomo',
  debug: false
});

Vue.use(VueLazyLoad, {
  preLoad: 1,
  // error: require('../static/img/loading/loading-16-9.jpg'),
  loading: require('../static/img/loading/loading-16-9.jpg'),
  attempt: 2,
})
router.beforeEach((to, from , next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if(radiogtag){
    radiogtag.page(to.fullPath)
    radiogtag.twPage();
  }
  if(to.fullPath.indexOf('/francais') != -1){
    if(frenchgtag){
      frenchgtag.page(to.fullPath)
    }
  }
  // gtag('config', 'G-YSD2Q29TGC', {
  //   page_path:to.fullPath,
  //   'debug_mode':true
  // });
  Vue.prototype.$policyDialog.showPolicyDialog();
  // Vue.prototype.$dangerIpDialog.showDangerIpDialog();
  Vue.prototype.$subscribeDialog.hideSubscribeDialog();
  Vue.prototype.$articleDialog.hideArticleDialog();
  Vue.prototype.getIp();
  next();
});
// router.afterEach((to, from, next) => {
  
// });

// 过滤返回的html字符串
Vue.prototype.removeHtmlStyle = function (html) {
  var rel = /style\s*?=\s*?([‘"])[\s\S]*?\1/
  var newHtml = ''
  if (html) {
    newHtml = html.replace(rel, '')
  }
  return newHtml
}
Vue.prototype.filterUrl = function(str){
  var urlTitle = str;
  // urlTitle = urlTitle.replace(/[\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?|\“|\”|\‘|\’|\·|\，]/g,"");
  urlTitle = urlTitle.split(' ').join('-');
  // urlTitle = urlTitle.replace(/[\u4e00-\u9fa5]/g,'');
  urlTitle = urlTitle.replace(/[^a-zA-z0-9-]+/g,'');
  urlTitle = urlTitle.replace(/-{2,}/g,'-');
  urlTitle = urlTitle.replace(/^-/,'');
  urlTitle = urlTitle.replace(/\-$/,'');
  if(urlTitle != ''){
    return urlTitle
  }else{
    urlTitle = 'radio-cgtn';
    return urlTitle
  } 
}
Vue.prototype.getIp = function(){
  $.ajax({
    url: "https://aezfm.meldingcloud.com/accesscheck/ip",
    type: "GET",
    dataType: "jsonp", //指定服务器返回的数据类型
    jsonp: "callback",
    success: function (data) {
      if('data' in data){
        if('country' in data.data){
          sessionStorage.setItem("countryCode", data.data.country);
          console.log(data.data)
        }
      }
    },
    error:function(){
      console.log('获取ip失败')
    }
  });
}

Vue.prototype.resetJetLagTime = function(flagNum,time){
  var _this = this , _flagNum = flagNum , _time , resetHour = parseInt(time.split(':')[0]) , resetMinutes = time.split(':')[1];
  resetHour = resetHour - _flagNum;
  if(_this.jetLag < 0){  //>东8区
    if(resetHour >= 24){
      resetHour = resetHour - 24;
    }
  }else{//<东8区
    if(resetHour < 0){
      resetHour = resetHour + 24;
    }
  }
  if(resetHour >= 0 && resetHour < 10){
    resetHour = '0' + resetHour;
  }
  _time = resetHour+':'+resetMinutes;
  return _time;
},

Vue.prototype.download = function(event,url,name,groupName) {
  var _this = this , _url = url , _name = name , _groupName = groupName , el = $(event.currentTarget) , timer = null , count = 60;
  el.addClass('noEvent');
  timer = setInterval(function(){
    count--;
    if (count <= 0) {
      clearInterval(timer);
      el.removeClass('noEvent');
    }
  },1000);
  // window.open('https://zhy-taezfm.meldingcloud.com/v3/downloadMedia?mediaUrl='+_url+'&title='+_name+'');
  // location.href = 'https://aezfm.meldingcloud.com/v3/downloadMedia?mediaUrl='+_url+'&title='+_name+'';
  // https://radio.cgtn.com/api
  location.href = 'https://radio.cgtn.com/api/v3/downloadMedia?mediaUrl='+_url+'&title='+_name+'';
  if(radiogtag){
    radiogtag.event('audio', 'downloadClkNum', _name, 1)
  }
  if(_groupName === 'fr'){
    if(frenchgtag){
      frenchgtag.event('audio', 'downloadClkNum', _name, 1)
    }
  }
},

Vue.prototype.$http=axios;

Vue.use(aLink);
Vue.use(MessageBox);
Vue.use(ShareDialog);
Vue.use(SubscribeDialog);
Vue.use(PolicyDialog);
Vue.use(DangerIpDialog);


// Vue.prototype.$post = post;

window.jquery = window.$ = jquery
window.Swiper = Swiper

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js